module.exports = __webpack_public_path__ + "static/media/m-spaceBubble.3054e554.png";